import { InfoIcon } from '@/assets/icons/info-icons/info';
import { Banner } from '@/components/basicComponents/banner';
import { useFormContext } from 'react-hook-form';
import { IRenderTemplateRow } from '../types';
import { evaluateDependencyItem, shouldRenderEmptyComponent } from '../utils';
import { themeVar } from '@/styles/theme';

interface InfoBlockComponentProps {
  row: IRenderTemplateRow;
  pageName?: string;
}

export const InfoBlockComponent = ({ row, pageName }: InfoBlockComponentProps) => {
  const { config, dependsOn } = row;
  const { watch } = useFormContext();
  const dependentValue = dependsOn ? watch(`${pageName}.${dependsOn.name}`) : null;
  const hasValidOrDependency: boolean = dependsOn?.or
    ? dependsOn.or.some((item: any) => {
        const dependentValue = watch(`${pageName}.${item.name}`);
        return evaluateDependencyItem(dependentValue, item);
      })
    : null;
  const hasValidAndDependency: boolean = dependsOn?.and
    ? dependsOn.and.every((item: any) => {
        const dependentValue = watch(`${pageName}.${item.name}`);
        return evaluateDependencyItem(dependentValue, item);
      })
    : null;

  if (shouldRenderEmptyComponent(dependsOn, dependentValue, hasValidOrDependency, hasValidAndDependency)) return <></>;

  return (
    <Banner
      title=""
      description={config?.content || ''}
      icon={<InfoIcon width={26} height={26} fill={themeVar('header.base')} />}
      bgColor={themeVar('layer.base')}
      color={themeVar('font.base')}
    />
  );
};
